// extracted by mini-css-extract-plugin
export default {"mainSection":"ResetPasswordPage_mainSection__Dk-99"};